export const LeadTimeNotificationChipComponentLocalize = {
  short: {
    'in-stock': $localize`:@@products.lead-time.in-stock:Lead time: 7 days`,
    unconfirmed: $localize`:@@products.lead-time.unconfirmed:Lead time: TBD`,
  },
  // Distinct ids from `short`: $localize keeps one source text per id, so sharing ids made the
  // extracted catalogs carry only the short wording and these strings never shipped.
  long: {
    'in-stock': $localize`:@@products.lead-time.long.in-stock:Ships Within: 7 days`,
    unconfirmed: $localize`:@@products.lead-time.long.unconfirmed:Lead time to be confirmed by Ideal Supply representative`,
  },
} as const;
